// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2LbFS","text":"SelectPayment_text__37nuJ","title":"SelectPayment_title__dBH2B","btn":"SelectPayment_btn__2Q2YQ"};